// extracted by mini-css-extract-plugin
export var blue = "_2e-f";
export var brand = "_2e-b";
export var darkGrey = "_2e-e";
export var disabled = "_2e-4";
export var disabledSubtle = "_2e-5";
export var error = "_2e-6";
export var green = "_2e-g";
export var grey = "_2e-d";
export var icon = "_2e-0";
export var inherit = "_2e-a";
export var lightGrey = "_2e-c";
export var orange = "_2e-i";
export var pink = "_2e-k";
export var primary = "_2e-1";
export var purple = "_2e-l";
export var red = "_2e-j";
export var secondary = "_2e-2";
export var success = "_2e-9";
export var tertiary = "_2e-3";
export var warning = "_2e-7";
export var warningSecondary = "_2e-8";
export var white = "_2e-m";
export var yellow = "_2e-h";